import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { createInitialStatePart, setReducerState } from '../utils/reduxUtils';
import { WebhooksInitialState, EventTypeState } from '../models/webhooks';
import { WebhookState } from '../models/webhook';
import { loadWebhooksListAction, CreateWebhookAction } from '../actionTypes/webhooks';
import { FailedResponse } from '../models/common';
import { RootState } from '../store';

const STATE_KEY = 'webhooks';
const initialState = {
  ...createInitialStatePart('webhookList', []),
  ...createInitialStatePart('eventTypes', []),
  activeModal: {}
};

const webhooks = createSlice({
  name: STATE_KEY,
  initialState: initialState as WebhooksInitialState,
  reducers: {
    loadWebhooksDetails: (state) => {
      return state;
    },
    loadWebhooksList: (state, action: PayloadAction<loadWebhooksListAction>) => {
      return setReducerState('loading', 'webhookList', { state, action });
    },
    loadWebhooksListSuccess: (state, action: PayloadAction<WebhookState[]>) => {
      return setReducerState('loaded', 'webhookList', { state, data: action.payload });
    },
    loadWebhooksListFail: (state, action: PayloadAction<FailedResponse>) => {
      return setReducerState('error', 'webhookList', { state, error: action.payload });
    },
    loadEventTypes: (state, action: PayloadAction<loadWebhooksListAction>) => {
      return setReducerState('loading', 'eventTypes', { state, action });
    },
    loadEventTypesSuccess: (state, action: PayloadAction<EventTypeState[]>) => {
      return setReducerState('loaded', 'eventTypes', { state, data: action.payload });
    },
    loadEventTypesFail: (state, action: PayloadAction<FailedResponse>) => {
      return setReducerState('error', 'eventTypes', { state, error: action.payload });
    },
    createWebhook: (state, action:  PayloadAction<CreateWebhookAction>) => {
      return state;
    },
    createWebhookSuccess: (state, action: PayloadAction<WebhookState>) => {
      return {
        ...state,
        webhookList: [...state.webhookList, action.payload]
      };
    },
    createWebhookFail: (state) => {
      return state;
    },
    setActiveModalDetails: (state, action) => {
      return { ...state, activeModal: action.payload };
    },
  },
});

//Actions
export const webhooksActions = webhooks.actions;

//Selectors
export const eventTypes = (state: RootState) => state.webhooks.eventTypes;
export const modalState = (state: RootState) => state.webhooks.activeModal;
export const webhooksList = (state: RootState) => state.webhooks.webhookList;

//Reducers
export default webhooks.reducer;
